import type { CSSProperties } from "react";
import React, { useState } from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { CameraInfo } from "lib/types";
import type { CollapseProps } from "antd";
import { Collapse, theme } from "antd";
import { SvgMapMarker } from "ui/svgs";
import { getSiteCameras } from "pages/service";
import { showToast } from "ui/components/common";
import CameraAITable from "./camera-ai-table";

function SiteCollapse({ site }) {
  const { token } = theme.useToken();
  const [activeKey, setActiveKey] = React.useState<string[]>(["1"]);
  const [loading, setLoading] = React.useState(false);
  const [cameras, setCameras] = useState<CameraInfo[]>([]);

  const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: "none",
  };

  const getItems: (panelStyle: CSSProperties) => CollapseProps["items"] = (
    panelStyle,
  ) => [
    {
      key: "1",
      label: (
        <div className="flex items-center">
          <SvgMapMarker
            width="14"
            className="fill-neutral-500 inline-block mr-2"
          />
          <p>{site?.name}</p>
          <p className="text-[#BDBDBD] px-2">|</p>
          <p>{site?.details?.address || ""}</p>
        </div>
      ),
      children: (
        <CameraAITable
          cameras={cameras}
          loading={loading}
          setCameras={(cameras) => setCameras(cameras)}
        />
      ),
      style: panelStyle,
    },
  ];

  const loadCameraData = async () => {
    setLoading(true);
    const data = await getSiteCameras(site.orgId, site?.id, "", true);
    setLoading(false);
    if (data?.status !== 200) {
      showToast(1, "Failed to get camera list, please try again later"); 
      return;
    }

    const cameras = data?.data?.data;
    setCameras(cameras);
  };

  return (
    <Collapse
      className="mb-4"
      accordion={true}
      bordered={false}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined rotate={isActive ? 90 : 0} />
      )}
      style={{ background: token.colorBgContainer }}
      items={getItems(panelStyle)}
      onChange={() => {
        if (cameras.length === 0) {
          loadCameraData();
        }
      }}
    />
  );
}

export default SiteCollapse;
